<template>
  <div class="media-image-list-container">
    <el-row>
      <el-button type="primary" @click="goCreatePage" >添加</el-button>
    </el-row>
    <el-table
      v-loading="listLoading"
      :data="list"
      style="width: 100%">
      <el-table-column
        width="120"
        align="center"
        prop="seq"
        label="顺序"
      >
      </el-table-column>
      <el-table-column
        prop="title">
        <template slot="header" slot-scope="scope">
          <div>标题</div>
          <el-input
            v-model="search.title"
            @change="quickSearch"
            placeholder="搜索"/>
        </template>
      </el-table-column>
      <el-table-column
        :formatter="formatDate"
        label="发布时间时间"
        prop="publishDate">
      </el-table-column>
      <el-table-column
        :formatter="formatDate"
        label="创建时间"
        prop="createDate">
      </el-table-column>
      <el-table-column
        label="操作"
        width="250"
        algin="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="table-footer">
      <el-pagination
        v-show="totalCount>0"
        @size-change="handleSizeChange"
        :current-page="currentPage"
        :page-size="pageSize"
        :total="totalCount"
        background
        layout="total, sizes, prev, pager, next"
        @current-change="handleCurrentChange">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  import * as moment from 'moment'
  import { getSubjectList, deleteSubject } from '@/api/cms'

  export default {
    name: 'CmsContentList',
    data() {
      return {
        list: [],
        listLoading: true,
        search: {},
        totalCount: 0, // 默认数据总数
        pageSize: 20, // 每页的数据条数
        currentPage: 1, // 默认开始页面
        listQuery: {},
        forumId: null
      }
    },
    created() {
      this.forumId = this.$route.meta.forumId
      this.getList()
    },
    watch: {
      '$route'(to, from) {
        this.forumId = this.$route.meta.forumId
        this.getList()
      }
    },
    mounted() {
    },
    methods: {
      handleSizeChange(val) {
        this.pageSize = val
        this.getList()
      },
      goCreatePage() {
        const pushName = this.getRouteName()
        this.$router.push({ name: pushName, params: {forumId: this.forumId}})
      },
      handleEdit(index, row) {
        const pushName = this.getRouteName(row.id)
        this.$router.push({ name: pushName, params: { subjectId: row.id, forumId: this.forumId }})
      },
      handleDelete(index, row) {
        this.$confirm('此操作将永久删除该内容, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          this.deleteAction(this.list[index].id)
        }).catch(() => {
        })
      },
      handleCurrentChange(val) {
        this.currentPage = val
        this.getList()
      },
      quickSearch() {
        this.getList()
      },
      getList() {
        this.listLoading = true
        this.listQuery = {
          pageNum: this.currentPage,
          pageSize: this.pageSize,
          forumId: this.forumId
        }
        this.listQuery = Object.assign(this.listQuery, this.search)
        getSubjectList(this.listQuery).then(response => {
          const data = response.data
          this.list = data.list
          this.currentPage = data.pageNum
          this.totalCount = data.count
          this.listLoading = false
        })
      },
      deleteAction(userId) {
        const params = {
          id: userId,
          status: -2
        }
        deleteSubject(params).then(response => {
          const data = response.data
          if (data) {
            this.$message({
              message: '删除成功',
              type: 'success',
              showClose: true,
              duration: 1000
            })
            this.getList()
          }
        })
      },
      formatDate: function(row, column) {
        const date = row[column.property]
        return date && moment(date).format('YYYY-MM-DD HH:mm:ss')
      },
      getRouteName (id) {
        const stateName = this.$route.name
        let pushName = ''
        if (stateName === 'MediaImageList') {
          pushName = id ? 'MediaImageEdit' : 'MediaImageCreate'
        } else if (stateName === 'MediaVideoList') {
          pushName = id ? 'MediaVideoEdit' : 'MediaVideoCreate'
        }
        return pushName
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .media-image-list-container {
    margin: 30px 15px;
    .action-header {
      padding: 0 10px 10px 10px;
    }
    .el-table {
      th {
        div {
          line-height: 20px;
        }
        .el-select {
          padding-left: 0;
          padding-right: 0;
          .el-input {
            padding-left: 0;
            padding-right: 0;
          }
        }
      }
      th>{
        .cell {
          text-overflow: clip;
        }
      }
    }

    .table-footer {
      text-align: center;
      margin-top: 30px;
    }

    .el-date-editor.el-input {
      width: 140px;
    }

    .el-input__prefix {
      left: 10px
    }

    .el-input__suffix {
      right: 10px;
    }

    .el-input--prefix .el-input__inner {
      padding-left: 25px;
      padding-right: 20px;
    }

    .demonstration {
      display: block;
      padding-bottom: 15px;
    }

    .input-win {
      width: 200px !important;
    }

    .input-win .el-input__prefix {
      left: 5px;
    }

    .el-button--text {
      color: #606266
    }
    .el-button--text:hover {
      color: #409EFF;
      text-decoration: underline;
    }
    .el-button+.el-button {
      margin-left: 0;
    }
  }
</style>
